import { webApi } from '@mi-front/api-clients';
import { Box } from '@mui/material';
import { CreateVideoEditionProjectButton } from './CreateVideoEditionProjectButton';
import { FragmentVideoEditionsCategoryChips } from './FragmentVideoEditionsCategoryChips';
import { FragmentVideoEditionsProjectGrid } from './FragmentVideoEditionsProjectGrid';
import { FragmentVideoEditionsTabSegmentEmpty } from './FragmentVideoEditionsTabSegmentEmpty';
import { useVideoEditionsProjectCategoryTabs } from '../hooks/useVideoEditionsProjectCategoryTabs';

export interface FragmentVideoEditionsProjectListProps {
  fragmentId: string;
  projects: webApi.EnrichedVideoEditorProjectListItemDto[];
  uploadsByPlatform: Map<string, webApi.FragmentSocialUploadItemDto[]> | undefined;
  onCloneProject: (project: webApi.EnrichedVideoEditorProjectListItemDto) => void;
}

/**
 * Chip navigation plus draft/generated grids when the fragment has at least one project.
 */
export function FragmentVideoEditionsProjectList({
  fragmentId,
  projects,
  uploadsByPlatform,
  onCloneProject,
}: FragmentVideoEditionsProjectListProps) {
  const { draftProjects, generatedProjects } = useVideoEditionsProjectCategoryTabs(projects);

  return (
    <FragmentVideoEditionsCategoryChips
      header={
        <Box sx={{ ml: 2 }}>
          <CreateVideoEditionProjectButton
            fragmentId={fragmentId}
            currentProjectCount={projects.length}
          />
        </Box>
      }
      draftCount={draftProjects.length}
      generatedCount={generatedProjects.length}
      draftContent={
        draftProjects.length ? (
          <FragmentVideoEditionsProjectGrid
            projects={draftProjects}
            uploadsByPlatform={uploadsByPlatform}
            onCloneProject={onCloneProject}
          />
        ) : (
          <FragmentVideoEditionsTabSegmentEmpty variant="draft" />
        )
      }
      generatedContent={
        generatedProjects.length ? (
          <FragmentVideoEditionsProjectGrid
            projects={generatedProjects}
            uploadsByPlatform={uploadsByPlatform}
            onCloneProject={onCloneProject}
          />
        ) : (
          <FragmentVideoEditionsTabSegmentEmpty variant="generated" />
        )
      }
    />
  );
}
